/* tslint:disable */
/* eslint-disable */
/**
 * Livescore Backend API
 * API for sports data with dual-layer caching
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiLivescoreDateOddsGet200Response } from '../models';
// @ts-ignore
import type { ApiLivescoreLiveGet200Response } from '../models';
// @ts-ignore
import type { ApiUpcomingMatchesGet200Response } from '../models';
// @ts-ignore
import type { ApiUpcomingMatchesIdsGet200Response } from '../models';
/**
 * MatchesApi - axios parameter creator
 * @export
 */
export const MatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateGet', 'date', date)
            const localVarPath = `/api/livescore/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet: async (date: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('apiLivescoreDateOddsGet', 'date', date)
            const localVarPath = `/api/livescore/{date}/odds`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/livescore/live`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upcoming-matches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesIdsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upcoming-matches/ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesOldGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/upcoming-matches-old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatchesApi - functional programming interface
 * @export
 */
export const MatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get matches for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiLivescoreDateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get odds for the provided date
         * @param {string} date Date in YYYY-MM-DD format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreDateOddsGet(date: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreDateOddsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreDateOddsGet(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiLivescoreDateOddsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLivescoreLiveGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLivescoreLiveGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLivescoreLiveGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiLivescoreLiveGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpcomingMatchesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUpcomingMatchesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpcomingMatchesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiUpcomingMatchesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpcomingMatchesIdsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUpcomingMatchesIdsGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpcomingMatchesIdsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiUpcomingMatchesIdsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUpcomingMatchesOldGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiUpcomingMatchesGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUpcomingMatchesOldGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MatchesApi.apiUpcomingMatchesOldGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MatchesApi - factory interface
 * @export
 */
export const MatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatchesApiFp(configuration)
    return {
        /**
         * Get matches for the provided date
         * @param {MatchesApiApiLivescoreDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateGet(requestParameters: MatchesApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreDateGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get odds for the provided date
         * @param {MatchesApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreDateOddsGet(requestParameters: MatchesApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreDateOddsGet200Response> {
            return localVarFp.apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * Get live matches
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLivescoreLiveGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiLivescoreLiveGet200Response> {
            return localVarFp.apiLivescoreLiveGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get upcoming matches for the next 3 days from configured leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiUpcomingMatchesGet200Response> {
            return localVarFp.apiUpcomingMatchesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Upcoming matches ids for today and yesterday from all leagues
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesIdsGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiUpcomingMatchesIdsGet200Response> {
            return localVarFp.apiUpcomingMatchesIdsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get upcoming matches for the next week from configured leagues. This route is deprecated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUpcomingMatchesOldGet(options?: RawAxiosRequestConfig): AxiosPromise<ApiUpcomingMatchesGet200Response> {
            return localVarFp.apiUpcomingMatchesOldGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLivescoreDateGet operation in MatchesApi.
 * @export
 * @interface MatchesApiApiLivescoreDateGetRequest
 */
export interface MatchesApiApiLivescoreDateGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof MatchesApiApiLivescoreDateGet
     */
    readonly date: string
}

/**
 * Request parameters for apiLivescoreDateOddsGet operation in MatchesApi.
 * @export
 * @interface MatchesApiApiLivescoreDateOddsGetRequest
 */
export interface MatchesApiApiLivescoreDateOddsGetRequest {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof MatchesApiApiLivescoreDateOddsGet
     */
    readonly date: string
}

/**
 * MatchesApi - object-oriented interface
 * @export
 * @class MatchesApi
 * @extends {BaseAPI}
 */
export class MatchesApi extends BaseAPI {
    /**
     * Get matches for the provided date
     * @param {MatchesApiApiLivescoreDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiLivescoreDateGet(requestParameters: MatchesApiApiLivescoreDateGetRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiLivescoreDateGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get odds for the provided date
     * @param {MatchesApiApiLivescoreDateOddsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiLivescoreDateOddsGet(requestParameters: MatchesApiApiLivescoreDateOddsGetRequest, options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiLivescoreDateOddsGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get live matches
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiLivescoreLiveGet(options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiLivescoreLiveGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get upcoming matches for the next 3 days from configured leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiUpcomingMatchesGet(options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiUpcomingMatchesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upcoming matches ids for today and yesterday from all leagues
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiUpcomingMatchesIdsGet(options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiUpcomingMatchesIdsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get upcoming matches for the next week from configured leagues. This route is deprecated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatchesApi
     */
    public apiUpcomingMatchesOldGet(options?: RawAxiosRequestConfig) {
        return MatchesApiFp(this.configuration).apiUpcomingMatchesOldGet(options).then((request) => request(this.axios, this.basePath));
    }
}

